import { configureStore } from "@reduxjs/toolkit";
import modalSlice from "./modal.slice";
import meSlice from "./me.slice";
import categorySlice from "./categories.slice";
import questionsSlice from "./questions.slice";
import answerSlice from "./answer.slice";

export default configureStore({
  reducer: {
    modal: modalSlice,
    me: meSlice,
    category: categorySlice,
    questions: questionsSlice,
    answer: answerSlice,
  },
});
